module.exports = __webpack_public_path__ + "static/media/jallu_pena___vainaja.d43a4a13.png";